import {
  type LearnerFormRequest,
  type OnboardingResult,
  TestMethod,
  type UserMeasurement,
} from './core/type';

import { validateDateOfBirth } from 'helpers';

import { MAX_ADDITIONAL_SCORE } from '../../constants';

export const validMeasurementInput = (
  type: keyof UserMeasurement,
  value: string | null | undefined,
) => {
  if (!value || value === 'null' || value === 'undefined') {
    return true;
  }

  const numberValue = parseFloat(value);

  switch (type) {
    case 'height':
      return numberValue >= 100 && numberValue <= 250;

    case 'weight':
      return numberValue >= 2 && numberValue <= 150;

    case 'bodyFat':
      return numberValue >= 5 && numberValue <= 50;

    case 'skeletalMuscle':
      return numberValue >= 5 && numberValue <= 60;

    case 'visceralFatLevel':
      return numberValue >= 1 && numberValue <= 30;

    case 'restingMetabolism':
      return numberValue >= 385 && numberValue <= 3999;

    default:
      return false;
  }
};

export const renderMeasurementError = (
  type: keyof UserMeasurement,
  value: string | null | undefined,
) => {
  if (type === 'height' && !validMeasurementInput('height', value)) {
    return 'Please enter between 100 and 250';
  }

  if (type === 'weight' && !validMeasurementInput('weight', value)) {
    return 'Please enter between 2 and 150';
  }

  if (type === 'bodyFat' && !validMeasurementInput('bodyFat', value)) {
    return 'Please enter between 5 and 50';
  }

  if (type === 'skeletalMuscle' && !validMeasurementInput('skeletalMuscle', value)) {
    return 'Please enter between 5 and 60';
  }

  if (type === 'visceralFatLevel' && !validMeasurementInput('visceralFatLevel', value)) {
    return 'Please enter between 1 and 30';
  }

  if (type === 'restingMetabolism' && !validMeasurementInput('restingMetabolism', value)) {
    return 'Please enter between 385 and 3999';
  }
};

export const renderDateOfBirthError = (
  type: keyof LearnerFormRequest,
  dayOfBirth: number | null | undefined,
  monthOfBirth: number | null | undefined,
  yearOfBirth: number | null | undefined,
) => {
  if (dayOfBirth && dayOfBirth > 0 && !monthOfBirth) {
    return type === 'monthOfBirth' ? 'Please select month!' : undefined;
  }

  if (
    // dayOfBirth &&
    // dayOfBirth > 0 &&
    monthOfBirth &&
    monthOfBirth >= 0 &&
    (yearOfBirth === -1 || !yearOfBirth)
  ) {
    return type === 'yearOfBirth' ? 'Please select year!' : undefined;
  }

  // if (
  //   dayOfBirth &&
  //   dayOfBirth > 0 &&
  //   monthOfBirth &&
  //   monthOfBirth >= 0 &&
  //   yearOfBirth &&
  //   yearOfBirth > 0
  // ) {
  //   const date = new Date(yearOfBirth, monthOfBirth, dayOfBirth).getTime();
  //   const now = new Date().getTime() - 1000 * 60 * 60 * 24 * 2; // two days ago;

  //   if (!validateDateOfBirth(dayOfBirth, monthOfBirth, yearOfBirth) || date > now) {
  //     return type === 'dayOfBirth' ? 'The date is invalid!' : undefined;
  //   }
  // }
};

export const isWrongAge = (year: number) => {
  if (Number(year) < 1) {
    return false;
  }

  const currentYear = new Date().getFullYear();

  return Number(year) >= currentYear || Number(year) < currentYear - 100;
};

export const getOnboardingTotalScore = (result: OnboardingResult) => {
  const totalScore = result.answers.reduce((total, e) => {
    if (
      [TestMethod['Enter rep count'], TestMethod['Enter score']].includes(e.functionalTest.method)
    ) {
      const additionalScore = e.functionalTest.isAddition
        ? Math.min(MAX_ADDITIONAL_SCORE, e.scoreAddition || 0)
        : 0;

      total += (Math.min(e.score, e.functionalTest.maxScore) || 0) + additionalScore;
    }

    return total;
  }, 0);

  return totalScore;
};

export const getOnboardingMaxScore = (result: OnboardingResult) => {
  const maxScore = result.answers.reduce((total, e) => {
    if (
      [TestMethod['Enter rep count'], TestMethod['Enter score']].includes(e.functionalTest.method)
    ) {
      const additionalScore = e.functionalTest.isAddition ? MAX_ADDITIONAL_SCORE : 0;

      total += (e.functionalTest.maxScore || 0) + additionalScore;
    }

    return total;
  }, 0);

  return maxScore;
};
